import React from 'react';

const getMessageWithApprovers = (defaultMessage, currentApprovers) => {
  const names = currentApprovers.map(({ name }) => name);

  const addOrOnLastName = { type: 'disjunction' };
  const approvers = new Intl.ListFormat('en', addOrOnLastName).format(names);

  return (
    <>
      {defaultMessage} and is pending approval by <b>{approvers}.</b>
    </>
  );
};

export const getMessageOnStaffingRequestSuccess = (staffing) => {
  const defaultMessage = 'Staffing request has been submitted';
  const currentApprovers = staffing.approvalChains[0]?.currentApprovers;
  const hasApprovers = currentApprovers?.length > 0;

  // Check if is preapproved/bypass, satisfied when created.
  if (staffing.approvalChains[0]?.satisfied) {
    return 'Staffing request has been open';
  }

  if (hasApprovers) {
    return getMessageWithApprovers(defaultMessage, currentApprovers);
  }

  return defaultMessage;
};
